import React from "react";
import { PageLayout } from "../layout";
import { observer } from "mobx-react";
import { useRootStore } from "../../store/contexts";
import JupiterPage from './JupiterPage';
import { useNavigate } from "react-router-dom";
import { DashboardContainer } from "../../dashboard";
import { CssBaseline } from "@mui/material";
import { TenantSetupGuide } from "../../entities/tenantProfile/components/common/TenantSetupGuide";

export const HomePage = observer(() => {
  const rootStore = useRootStore();
  const navigate = useNavigate();
  const { authStore, langStore } = rootStore;

  const isLoggedIn = authStore.status === "logged" && authStore.me !== null;

  const handleLogoClick = () => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  };

  if (!isLoggedIn) {
    return (
      <>
        <CssBaseline />
        <JupiterPage
          onClick={handleLogoClick}
          currentLang={langStore.language}
          onLanguageChange={(lang: string) => langStore.setLanguage(lang as any)}
        />
      </>
    );
  }

  return (
    <PageLayout>
      <TenantSetupGuide />
      <DashboardContainer />
    </PageLayout>
  );
});
